// oauthConfig.js
import OAuth from "oauth-1.0a";
import CryptoJS from "crypto-js";

function hashFunction(baseString, key) {
    return CryptoJS.HmacSHA1(baseString, key).toString(CryptoJS.enc.Base64);
}
console.log(process.env.REACT_APP_CONSUMER_KEY);

const oauth = new OAuth({
    consumer: {
        key: process.env.REACT_APP_CONSUMER_KEY,
        secret: process.env.REACT_APP_CONSUMER_SECRET
    },
    signature_method: 'HMAC-SHA1',
    hash_function: hashFunction,
});

export default oauth;
 